import styled from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { $robotoFontFamily } from "@similarweb/styles";

export const StyledFooter = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    height: 50px;
    padding: 0 16px 8px 38px;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledButtons = styled.div`
    display: flex;
    align-items: center;

    button:first-child {
        margin-right: 8px;
    }
`;

export const StyledAmountSelected = styled.div<{ hasValues: boolean }>`
    ${({ hasValues }) =>
        hasValues
            ? setFont({
                  $size: 16,
                  $weight: 500,
                  $family: $robotoFontFamily,
                  $color: colorsPalettes.carbon[500],
              })
            : setFont({
                  $size: 16,
                  $weight: 400,
                  $family: $robotoFontFamily,
                  $color: colorsPalettes.carbon[250],
              })}
    line-height: 20px;
`;

export const StyledModalTitle = styled.div`
    ${setFont({ $size: 20, $weight: 500, $family: "DM Sans", $color: colorsPalettes.carbon[500] })};
    line-height: 24px;
    margin-bottom: 36px;
`;

export const StyledModalSubTitle = styled.div`
    ${setFont({
        $size: 16,
        $weight: 400,
        $family: $robotoFontFamily,
        $color: colorsPalettes.carbon[400],
    })};
    line-height: 20px;
    margin-bottom: 24px;
`;

export const StyledSearchField = styled.div`
    border-top-left-radius: 6px;
    flex-grow: 1;
    height: 40px;

    & > div,
    & .input-container {
        height: 100%;
    }
`;

export const CUSTOM_ADD_FIELDS_MODAL_STYLES = {
    content: { padding: "20px 24px 0 24px", width: 712, height: 456, border: 0 },
    overlay: {
        backgroundColor: rgba(colorsPalettes.midnight["300"], 0.7),
    },
};
